/* @flow */
import _ from 'lodash';
import liferay from '../../services/liferay';
import type { Action, AsyncAction, SimplifiedTrack, SearchParams } from '../../types';
import { searchParamsProps } from '../../types/SearchParams';

const onFailure = (error: Object) => console.warn(error);

const initializeApp = (): AsyncAction => {
  return {
    type: 'INITIALIZE_APP_REQUEST',
    promise: liferay.initialize(),
    meta: { onFailure },
  };
};

const hideSnackbar = (): Action => {
  return { type: 'HIDE_SNACKBAR' };
};

const notImplemented = (): Action => {
  return { type: 'NOT_IMPLEMENTED' };
};

const setSearch = (params: SearchParams): Action => {
  return {
    type: 'SET_SEARCH',
    payload: _.pick(params, searchParamsProps),
  };
};

const downloadTracks = (tracks: SimplifiedTrack[]): AsyncAction => {
  return {
    type: 'FETCH_TRACKS_DOWNLOAD_URL_REQUEST',
    promise: liferay.tracks.downloadUrl(tracks),
    meta: { onFailure },
  };
};

const resetTracksDownloadUrl = (): Action => {
  return {
    type: 'RESET_TRACKS_DOWNLOAD_URL',
  };
};

const displayMessage = (message: string, isError: boolean, isSticky?: boolean): Action => {
  return {
    type: 'DISPLAY_MESSAGE',
    payload: { message, isError, isSticky },
  };
};

export default {
  initializeApp,
  hideSnackbar,
  setSearch,
  notImplemented,
  downloadTracks,
  resetTracksDownloadUrl,
  displayMessage,
};
